import { formatMesAno } from "../../utils/Formatter";

export function getFabricantes(fetch) {
    return fetch().get("/outros/GetFabricantesIndefinidos");
}